// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/shell/LiveRegion.tsx
// PLAN2 WP10 — §7.10. Two visually hidden live regions; useAnnounce() clears then sets so repeats are announced.
import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from "react";
import { TESTIDS } from "~/utils/testids";

type Announce = (text: string, opts?: { assertive?: boolean }) => void;
const AnnounceCtx = createContext<Announce>(() => undefined);
export const useAnnounce = () => useContext(AnnounceCtx);

export function LiveRegionProvider({ children }: { children: ReactNode }) {
  const [polite, setPolite] = useState("");
  const [assertive, setAssertive] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const announce = useCallback<Announce>((text, opts) => {
    const set = opts?.assertive ? setAssertive : setPolite;
    set("");
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => set(text), 30);
  }, []);
  return (
    <AnnounceCtx.Provider value={announce}>
      {children}
      <div role="status" aria-live="polite" className="sr-only" data-testid={TESTIDS.shell.liveRegion}>{polite}</div>
      <div role="status" aria-live="assertive" className="sr-only">{assertive}</div>
    </AnnounceCtx.Provider>
  );
}
